import { useParams } from "react-router";
import { ActivePracticeContextProvider } from "../contexts/ActivePracticeContextProvider";
import { qoGetSinglePractice } from "../utils/queryOptions";
import { useQuery } from "@tanstack/react-query";

export default function SinglePracticeView() {
  const { practiceId } = useParams();

  const { data: activePractice, isSuccess } = useQuery(
    qoGetSinglePractice({
      practiceId: Number(practiceId),
    })
  );

  // get practice with id
  return isSuccess ? (
    <>
      <ActivePracticeContextProvider isLive={false} practice={activePractice} />
    </>
  ) : (
    <div>yükleniyor</div>
  );
}
